import { atom } from "recoil"
export const completedSignUpFlagState = atom<boolean>({
  key: "atoms/signUp/completedSignUpFlagState",
  default: false,
})
